import axios from "../axiosInstance";

class FamilyGroupService {
  async getFamilyGroupOptions() {
    return axios.get(`familygroup`);
  }
}

export default new FamilyGroupService();
